





























































































































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { Constants } from '@/constants/constants';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import { masterModule } from '@/store/modules/entities/master.module';
import { customCompetencyModule } from '@/store/modules/frames/custom-competency.module';
import { Competency, CreateCustomCompetency, CompetencySelection, CustomCompetency } from '@/models/competency/competency';
import GExamCreateSelection from '@/views/GExamCreate/QuestionSetting/GExamCreateQuestionSettingCompetencySelection.vue';
import GCustomCompetencySelection from '@/views/GCustomCompetency/GCustomCompetencySelection.vue';
import GLoading from '@/components/GLoading.vue';
import { required } from 'vuelidate/lib/validators';
import GVTag from '@/components/GVTag.vue';
import GCompetencyLabel from '@/components/GCompetencyLabel.vue';
import GOptionalIcon from '@/components/GOptionalIcon.vue';

@Component({
  name: 'GCustomCompetency',
  components: {
    GVTag,
    GLoading,
    GTitleBar,
    GCustomBreadCrumb,
    GExamCreateSelection,
    GCustomCompetencySelection,
    GCompetencyLabel,
    GOptionalIcon,
  },
  computed: {},
  methods: {},
  validations: {
    createCustomCompetency: {
      name: { required },
    },
  },
})
export default class GCustomCompetency extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  listColumn: object[] = [];
  lazy: boolean = false;
  isRefresh: boolean = false;
  size: number = 24;
  isUpdate: boolean = false;
  updateID: number = 0;
  emptyError: boolean = false;
  sameNameError: boolean = false;
  processing: boolean = false;
  deleteSuccess: boolean = false;

  async mounted() {
    await masterModule.fetchCompetency();
    customCompetencyModule.clean();
    customCompetencyModule.fetchCustomCompetency();

    this.breadCrumbItems = [
      {
        title: this.$t('HOME').toString(),
        icon: 'ios-home',
        routerPath: '/pages/home',
      },
      { title: this.$t('SCHOOL_COMPETENCY').toString() },
    ];
    this.createColumn();
    this.lazy = true;
  }

  /**
   * 新規作成実行
   */
  handleCommit() {
    this.processing = true;
    if (this.isValid()) {
      customCompetencyModule.addCustomCompetency().then(() => {
        this.showInsertSuccessed();
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      });
    } else {
      this.processing = false;
    }
  }

  /**
   * 更新実行
   */
  handleUpdate() {
    this.processing = true;
    if (this.isValid()) {
      customCompetencyModule.updateCustomCompetency().then(() => {
        this.showUpdateSuccessed();
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      });
    } else {
      this.processing = false;
    }
  }

  handleUpdateCancel() {
    this.isUpdate = false;
    this.updateID = 0;
    customCompetencyModule.clean();
  }

  get createCustomCompetency(): CreateCustomCompetency {
    return customCompetencyModule.createCustomCompetency;
  }

  get selectionCognitive(): CompetencySelection {
    return customCompetencyModule.selectionCognitive;
  }
  get selectionSelf(): CompetencySelection {
    return customCompetencyModule.selectionSelf;
  }
  get selectionGift(): CompetencySelection {
    return customCompetencyModule.selectionGift;
  }
  get selectionCommunity(): CompetencySelection {
    return customCompetencyModule.selectionCommunity;
  }

  get competencyCognitiveIncludeIsValid(): Competency[] {
    return masterModule.competencyCognitive;
  }

  get competencySelfIncludeIsValid(): Competency[] {
    return masterModule.competencySelf;
  }

  get competencyGiftIncludeIsValid(): Competency[] {
    return masterModule.competencyGift;
  }

  get competencyCommunityIncludeIsValid(): Competency[] {
    return masterModule.competencyCommunity;
  }

  get competencyMap(): Map<number, Competency> {
    return masterModule.competencyMap;
  }

  get isNameInvalid(): boolean {
    this.$v.createCustomCompetency.name.$touch();
    return this.$v.createCustomCompetency.name.$dirty && this.$v.createCustomCompetency.name.$invalid;
  }

  get isNonCompetencySelected(): boolean {
    return (
      this.selectionCognitive.checkAllGroup.length === 0 &&
      this.selectionSelf.checkAllGroup.length === 0 &&
      this.selectionGift.checkAllGroup.length === 0 &&
      this.selectionCommunity.checkAllGroup.length === 0
    );
  }

  isValid(): boolean {
    this.checkName();
    return !this.isNameInvalid && !this.isNonCompetencySelected && !this.emptyError && !this.sameNameError;
  }

  checkEmptyName() {
    return this.createCustomCompetency.name === null || this.createCustomCompetency.name === undefined || this.createCustomCompetency.name === '';
  }

  checkSameName() {
    let sameNameCc: CustomCompetency = undefined;
    if (this.isUpdate) {
      sameNameCc = customCompetencyModule.customCompetencies.find((cc: CustomCompetency) => {
        return customCompetencyModule.editCustomCompetency.id !== cc.id && cc.name === customCompetencyModule.createCustomCompetency.name;
      });
    } else {
      sameNameCc = customCompetencyModule.customCompetencies.find((cc: CustomCompetency) => {
        return cc.name === customCompetencyModule.createCustomCompetency.name;
      });
    }
    if (sameNameCc) {
      this.sameNameError = true;
      return true;
    }

    this.sameNameError = false;
    return false;
  }

  checkName() {
    if (this.checkSameName()) {
      this.sameNameError = true;
    } else {
      this.sameNameError = false;
    }

    if (this.checkEmptyName()) {
      this.emptyError = true;
    } else {
      this.emptyError = false;
    }
    return !this.sameNameError && !this.emptyError;
  }

  get isProcessing(): boolean {
    return this.processing;
  }

  get customCompetencies() {
    return customCompetencyModule.customCompetencies;
  }

  rowDisableColor(row: CustomCompetency): string {
    if (!row.isValid) {
      return 'invalid-row';
    }
    return 'no-setting-row';
  }

  createColumn(): void {
    this.listColumn = [this.columnCustomCompetencyName, this.columnCompetencies, this.columnActions];
  }

  handleEdit(row: CustomCompetency) {
    this.isUpdate = true;
    customCompetencyModule.clean();
    customCompetencyModule.setUpdateID(row.id);
    customCompetencyModule.setName(row.name);
    row.competencies.forEach((cid) => {
      if (Constants.SelfCompetencyIDs.includes(cid)) {
        customCompetencyModule.setSelectionSelf(cid);
      } else if (Constants.GiftCompetencyIDs.includes(cid)) {
        customCompetencyModule.setSelectionGift(cid);
      } else if (Constants.CognitiveCompetencyIDs.includes(cid)) {
        customCompetencyModule.setSelectionCognitive(cid);
      } else if (Constants.CommunityCompetencyIDs.includes(cid)) {
        customCompetencyModule.setSelectionCommunity(cid);
      }
    });
    this.checkName();
  }

  handleDeleteConfirm(row: CustomCompetency) {
    let config = {
      title: this.$t('CONFIRM_DELETE_X', {value: row.name}).toString(),
      onOk: () => {
        this.loadingPage(
          () => {
            customCompetencyModule.deleteCustomCompetency(row.id).then((res) => {
              // 成功時、レスポンスは空 {}
              if (Object.keys(res).length === 0) {
                this.deleteSuccess = true;
                this.showDeleteSuccessed();
              }
            });
          },
          () => {
            if (this.deleteSuccess) {
              window.location.reload();
            }
          },
          3000
        );
      },
      onCancel: () => {
        return;
      },
    };
    this.$Modal.confirm(config);
  }

  get columnCustomCompetencyName(): any {
    return {
      title: this.$t('DISPLAY_LABEL').toString(),
      key: 'name',
      width: 320,
    };
  }

  get columnCompetencies(): any {
    return {
      title: this.$t('USE_COMPETENCY').toString(),
      slot: 'selected-competency',
    };
  }

  get columnActions(): any {
    return {
      title: this.$t('OPERATE').toString(),
      slot: 'actions',
      align: 'center',
      width: 100,
    };
  }
}
